import { StatutEchantillon } from '../../declaration/models/statut-echantillon.model';
import { Produit } from '../../habilitation/models/produit.model';
import { OperateurInformationsDomaine } from '../../intervenant/models/operateur-informations-domaine.model';
import { Operateur } from '../../intervenant/models/operateur.model';
import { Site } from '../../declaration/models/site.model';

export class TourneeEchantillon {
    static jsonMap = {
        id: { key: 'id', optional: true },
        codeProduit: { key: 'codeProduit', optional: true, default: '' },
        idOperateur: { key: 'idOperateur' },
        idMouvement: { key: 'idMouvement', optional: true },
        millesime: { key: 'millesime', optional: true },
        numero: { key: 'numero', optional: true, default: '' },
        ordre: { key: 'ordre', optional: true },
        codeStatut: { key: 'codeStatut', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' },
        volume: { key: 'volume', optional: true },
        idSite: { key: 'idSite', optional: true }
    };

    id: number;
    codeProduit: string;

    produit: Produit;

    idOperateur: number;
    infosOperateur: OperateurInformationsDomaine[] = [];
    operateur: Operateur;

    idMouvement: number;

    millesime: number;

    numero: string;

    ordre: number;

    codeStatut: string;

    logement: string;

    volume: number;

    idSite: number;
    site: Site;

    statut: StatutEchantillon;
}
